export interface OutreachContactList {
  id: string;
  name: string;
  private?: boolean;
  updatedAt?: string;
}

export type OutreachContactListResource = {
  attributes?: Record<string, unknown>;
  id: string;
};

export function getContactListAttribute(
  attributes: Record<string, unknown>,
  name: string
) {
  const snakeCaseName = name.replace(
    /[A-Z]/g,
    (letter) => `_${letter.toLowerCase()}`
  );

  return (
    attributes[name] ??
    attributes[name.replace(/[A-Z]/g, "-$&").toLowerCase()] ??
    attributes[snakeCaseName]
  );
}

export function normalizeContactList(
  contactList: OutreachContactListResource
): OutreachContactList {
  const attributes = contactList.attributes ?? {};

  return {
    id: contactList.id,
    name: getContactListAttribute(attributes, "name") as string,
    private: getContactListAttribute(attributes, "private") as
      | boolean
      | undefined,
    updatedAt: (getContactListAttribute(attributes, "updatedAt") ??
      getContactListAttribute(attributes, "createdAt")) as string | undefined,
  };
}

export function sortContactLists(contactLists: OutreachContactList[]) {
  return [...contactLists].sort((first, second) =>
    (second.updatedAt ?? "").localeCompare(first.updatedAt ?? "")
  );
}
